import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, ResponseContentType, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { tokenNotExpired } from 'angular2-jwt';
import { CookieService } from 'ngx-cookie-service';
declare var $: any;

@Injectable()
export class AuthService {

    authToken: any;
    api_url: string;
    group_api_url: string;
    common_api_url: string;
    config_url = '';
    website_url: string;
    paypal_url: string;

    constructor(private http: Http, private cookieService: CookieService) {
        //  this.api_url = 'http://dev.waz.encoreskydev.com:5050/admin/';
        //  this.common_api_url = 'http://dev.waz.encoreskydev.com:5050/';

        // this.api_url  =  "https://mywaz.com/api/admin/";
        // this.common_api_url = "https://mywaz.com/api/";

        // this.api_url  =  "http://23.20.152.247:8087/admin/";
        // this.common_api_url = "http://23.20.152.247:8087/";

        // this.api_url = "http://3.80.62.17:8087/admin/";
        // this.common_api_url = "http://3.80.62.17:8087/";
        // this.website_url="http://3.80.62.17:8087/";
        // this.paypal_url='https://api-m.sandbox.paypal.com';

        //LOCALHOST
        // this.api_url = 'http://localhost:8087/admin/';
        // this.common_api_url = 'http://localhost:8087/';
        // this.website_url = 'http://localhost:8087/';

        //TEST
        // this.api_url = "http://3.80.62.17:8087/admin/";
        // this.common_api_url = "http://3.80.62.17:8087/";
        // this.website_url="http://3.80.62.17:8087/";

        // //PRODUCTION
        // this.api_url = 'http://107.21.144.29:8087/admin/';
        // this.common_api_url = 'http://107.21.144.29:8087/';
        // this.website_url = 'http://107.21.144.29:8087/';
        // this.paypal_url = 'https://api-m.sandbox.paypal.com';

        //PRODUCTION
        this.api_url = 'https://api.mywaz.com/admin/';
        this.common_api_url = 'https://api.mywaz.com/';
        this.website_url = 'https://api.mywaz.com/';
        //   this.api_url = 'http://98.81.134.110:8087/admin/';
        // this.common_api_url = 'http://98.81.134.110:8087/';
        // this.website_url = 'http://98.81.134.110:8087/';
        this.paypal_url = 'https://api-m.sandbox.paypal.com';

    }

    getConfig() {
        this.config_url = window.location.origin + '/assets/config.json';
        return this.http.get(this.config_url)
            .map((response: Response) => response.json());
    }

    // Check user is autheticated or not.
    isAuthenticated = function () {
        return tokenNotExpired("admin_web_token");
    }

    // Get Headers
    getHeaderOption() {
        let headers = new Headers();
        headers.set('content-type', 'application/json');
        headers.set('Accept', 'application/json');
        let option = new RequestOptions({ headers: headers });
        return option
    }

    // Get auth header options
    getAuthHeaderOption() {

        this.authToken = localStorage.getItem('admin_web_token');
        let headers = new Headers();
        headers.set('content-type', 'application/json');
        headers.set('Accept', 'application/json');
        headers.set('Authorization', 'Bearer ' + this.authToken);
        let option = new RequestOptions({ headers: headers });
        return option;
    }

    getPaypalAuthHeaderOption() {

        var basicAuthString = btoa('Aedgc2Y1apNLtNIYVoRVwR6zCakY9Is5lQZ7igf_XT5HyfBT2fFbgT7b_fM9od9f_D2Y-qXLuvdcCISY:ELbl8-03NOIyWYKPMGEJLFLizC2sCW00lMlZRA6QH4aXaYQ6nwG-Jm7MQeNDC3zy_MGZFfRMlm4IkZNO');
        let headers = new Headers();
        headers.set('content-type', 'application/x-www-form-urlencoded');
        headers.set('Accept', 'application/json');
        headers.set('Authorization', 'Basic ' + basicAuthString);
        let option = new RequestOptions({ headers: headers });
        return option;
    }
    getPayAuthHeaderOption(accessToken) {

        let headers = new Headers();
        headers.set('content-type', 'application/json');
        headers.set('Accept', 'application/json');
        headers.set('Authorization', 'Bearer ' + accessToken);
        let option = new RequestOptions({ headers: headers });
        return option;
    }

    // Get auth header image options
    getAuthHeaderImageOption() {
        let headers = new Headers();
        headers.set('content-type', 'application/json');
        headers.append('Accept', 'application/json');
        headers.set('Authorization', 'Bearer ' + this.authToken);
        let option = new RequestOptions({ headers: headers });
        return option;
    }

    // Store token
    storeWebToken = function (token) {
        localStorage.removeItem('admin_web_token');
        localStorage.setItem('admin_web_token', token);
    }

    // Admin Login 
    login = function (credentials) {

        // return this.http.post(this.api_url + 'login', JSON.stringify(credentials), this.getHeaderOption()).map(res => res.json());
        return this.http.post(this.api_url + 'loginadmin', JSON.stringify(credentials), this.getAuthHeaderOption()).map(res => res.json());
    }
    // Admin loggedin 
    loggedin = function () {

        this.authToken = localStorage.getItem('admin_web_token');
        var headers = new Headers();
        headers.set('content-type', 'application/json');
        headers.set('Accept', 'application/json');
        headers.set('Authorization', 'Bearer ' + this.authToken);
        var option = new RequestOptions({ headers: headers });
        //return option;

        return this.http.get(this.api_url + 'loggedin', option).map(res => res.json());
    }
    // Get user list
    userList = function (pageNo, limit, searchStr, time) {
        return this.http.get(this.api_url + 'user-list/' + pageNo + "/" + limit + "?time=" + time + "&search=" + searchStr, this.getAuthHeaderOption()).map(res => res.json());
    }

    StatususerList = function (pageNo, limit, searchStr, time, status) {
        return this.http.get(this.api_url + 'get-users/' + pageNo + "/" + limit + "/" + status + "/?time=" + time + "&search=" + searchStr, this.getAuthHeaderOption()).map(res => res.json());
    }

    StatusadminList = function (pageNo, limit, searchStr, time, status) {
        return this.http.get(this.api_url + 'get-admin/' + pageNo + "/" + limit + "?time=" + time + "&search=" + searchStr, this.getAuthHeaderOption()).map(res => res.json());
    }

    // Change password
    changePassword = function (changePasswordData) {
        return this.http.put(this.common_api_url + 'change-password', JSON.stringify(changePasswordData), this.getAuthHeaderOption()).map(res => res.json());
    }

    // Get user detail by id.
    getUserDetail = function (id) {

    }

    // Get country list
    getCountryList = function () {

        return this.http.get(this.common_api_url + 'country/list', this.getHeaderOption()).map(res => res.json());
    }
    // Get country list
    getStateList = function (page, limit, searchStr) {
        return this.http.get(this.common_api_url + 'state/list/' + page + "/" + limit + "?search=" + searchStr, this.getHeaderOption()).map(res => res.json());
    }


    //get statelistbyid
    getStateListbyId = function (id) {
        return this.http.get(this.common_api_url + 'state/list/' + id, this.getHeaderOption()).map(res => res.json());
    }

    getCityListbyId = function (id) {
        return this.http.get(this.common_api_url + 'city/getcity/' + id, this.getHeaderOption()).map(res => res.json());
    }

    // Get City list
    getCityList = function (page, limit, searchStr) {
        // ;;
        return this.http.get(this.common_api_url + 'city/list/' + page + "/" + limit + "?search=" + searchStr, this.getHeaderOption()).map(res => res.json());
    }

    // get Time list
    getTimeList = function (page, limit, searchStr) {
        // ;;
        return this.http.get(this.common_api_url + 'time/list/' + page + "/" + limit + "?search=" + searchStr, this.getHeaderOption()).map(res => res.json());
    }

    //Manage Time
    manageTime = function (obj, type, id,) {
        if (type == "add") {
            return this.http.post(this.common_api_url + 'time/add/', { 'time': obj.time, "businessCharge": obj.businessCharge }, this.getAuthHeaderOption()).map(res => res.json());
        }
        else if (type == "edit") {
            return this.http.put(this.common_api_url + 'time/update/' + id, { 'time': obj.time, "businessCharge": obj.businessCharge }, this.getAuthHeaderOption()).map(res => res.json());
        }
        else if (type == "delete") {
            return this.http.get(this.common_api_url + 'time/delete/' + id, this.getAuthHeaderOption()).map(res => res.json());
        }
    }

    // get Year list
    getYearListPagination = function (page, limit, searchStr) {
        // ;;
        return this.http.get(this.common_api_url + 'year/list/' + page + "/" + limit + "?search=" + searchStr, this.getHeaderOption()).map(res => res.json());
    }

    //Manage Year
    manageYear = function (obj, type, id,) {

        if (type == "add") {
            return this.http.post(this.common_api_url + 'year/add/', { 'year': obj.year, "priority": obj.priority }, this.getAuthHeaderOption()).map(res => res.json());
        }
        else if (type == "edit") {
            return this.http.put(this.common_api_url + 'year/update/' + id, { 'year': obj.year, "priority": obj.priority }, this.getAuthHeaderOption()).map(res => res.json());
        }
        else if (type == "delete") {
            return this.http.get(this.common_api_url + 'year/delete/' + id, this.getAuthHeaderOption()).map(res => res.json());
        }
    }

    // Get language list
    getLanguageList = function () {
        return this.http.get(this.common_api_url + 'language/list', this.getHeaderOption()).map(res => res.json());
    }

    // Get logged-in user details
    getLoggedInUser = function () {
        return this.http.get(this.common_api_url + 'select', this.getAuthHeaderOption()).map(res => res.json());
    }

    // Close Modal
    cancelProcess = function () {
        $('.btn-close').click();
    }

    // Logout
    logout = function () {
        this.authToken = localStorage.getItem('admin_web_token');
        var headers = new Headers();
        headers.set('content-type', 'application/json');
        headers.set('Accept', 'application/json');
        headers.set('Authorization', 'Bearer ' + this.authToken);
        var option = new RequestOptions({ headers: headers });
        //return option;

        localStorage.removeItem('is_super_admin');
        localStorage.removeItem('admin_web_token');
        this.cookieService.delete("surveyTypeList");

        return this.http.get(this.api_url + 'loggedout', option).map(res => res.json());


    }

    // Upload profile Image
    uploadProfileImage = function (image) {
        return this.http.put(this.common_api_url + 'upload-image', JSON.stringify({ 'profile_pic': image }), this.getAuthHeaderImageOption()).map(res => res.json());
    }

    // Update user data
    updateUserProfile = function (userData) {
        return this.http.put(this.api_url + 'update', JSON.stringify(userData), this.getAuthHeaderOption()).map(res => res.json());
    }

    addAdmin = function (userData) {
        return this.http.put(this.api_url + 'add-admin', JSON.stringify(userData), this.getAuthHeaderOption()).map(res => res.json());
    }

    updateAdmin = function (userData) {
        return this.http.put(this.api_url + 'update-admin', JSON.stringify(userData), this.getAuthHeaderOption()).map(res => res.json());
    }


    // Get survey list
    getSurveyList = function (page, limit, surveyTypeId, categoryId, surveyStatus, searchStr, country_id) {
        return this.http.get(this.common_api_url + 'survey/all-survey/' + page + "/" + limit + "?type_id=" + surveyTypeId + "&category_id=" + categoryId + "&is_expired=" + surveyStatus + "&search=" + searchStr + "&country_id=" + country_id, this.getAuthHeaderOption()).map(res => res.json());
    }

    likesurveyusers = function (data) {
        return this.http.post(this.common_api_url + 'survey/all-like-survey-user/', data, this.getAuthHeaderOption()).map(res => res.json());
    }



    adminProfileUplod = function (formdata) {
        return this.http.post(this.api_url + 'profile-upload-admin', formdata).map(res => res.json());
        //return this.http.post(this.api_url + 'profile-upload-admin/11',formdata, this.getAuthHeaderOption()).map(res => res.json());
    }

    // Update user status
    updateUserStatus = function (userId) {
        return this.http.put(this.api_url + 'user-status/' + userId, {}, this.getAuthHeaderOption()).map(res => res.json());
    }

    deleteAdmin = function (userId) {
        return this.http.get(this.api_url + 'delete-admin/' + userId, this.getAuthHeaderOption()).map(res => res.json());
    }


    // Update user
    updateUser = function (data, id) {
        return this.http.put(this.api_url + 'update-user/' + id, JSON.stringify(data), this.getAuthHeaderOption()).map(res => res.json());
    }

    // Keypress Event
    keyPress(event: any) {
        const pattern = /[0-9\+\-\ ]/;
        let inputChar = String.fromCharCode(event.charCode);
        if (event.keyCode != 8 && !pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    // Get survey type list
    getSurveyTypeList = function () {
        return this.http.get(this.common_api_url + 'type/list', this.getAuthHeaderOption()).map(res => res.json());
    }

    // Get survey expiry date list
    getSurveyExpiryList = function () {
        return this.http.get(this.common_api_url + 'time/list', this.getAuthHeaderOption()).map(res => res.json());
    }

    getUser = function () {
        return this.http.get(this.api_url + 'get-users', this.getAuthHeaderOption()).map(res => res.json());
    }


    // Get survey category list
    getSurveyCategoryList = function (pageNo, limit) {
        if (pageNo && limit) {
            return this.http.get(this.common_api_url + 'category/list/' + pageNo + "/" + limit, this.getAuthHeaderOption()).map(res => res.json());
        }
        return this.http.get(this.common_api_url + 'category/list', this.getAuthHeaderOption()).map(res => res.json());

    }

    // Get survey Profession list
    getProfessionList = function (pageNo, limit) {
        if (pageNo && limit) {
            return this.http.get(this.common_api_url + 'profession/list/' + pageNo + "/" + limit, this.getAuthHeaderOption()).map(res => res.json());
        }
        return this.http.get(this.common_api_url + 'profession/list/', this.getAuthHeaderOption()).map(res => res.json());

    }
    // Update survey
    updateSurvey = function (data, id) {
        return this.http.put(this.common_api_url + 'survey/update/' + id, JSON.stringify(data), this.getAuthHeaderOption()).map(res => res.json());
    }

    // Delete survey
    deleteSurvey = function (id) {
        return this.http.get(this.common_api_url + 'survey/remove/' + id, this.getAuthHeaderOption()).map(res => res.json());
    }

    // Update survey status
    updateSurveyStatus = function (id) {
        return this.http.put(this.common_api_url + 'survey/survey-status/' + id, {}, this.getAuthHeaderOption()).map(res => res.json());
    }

    updateViolationVideo = function (id,section_type) {
        return this.http.get(this.api_url + 'update-violation-video/'+section_type+"/" + id , this.getAuthHeaderOption()).map(res => res.json());
    }

    deleteVideoReport = function (id) {
        return this.http.get(this.api_url + 'delete-video-report/' + id  , this.getAuthHeaderOption()).map(res => res.json());
    }
    //Manage Language
    manageLanguage = function (obj, id, type) {
        if (type == "add") {
            return this.http.post(this.common_api_url + 'language/add/', { "language": obj.language, 'language_code': obj.language_code }, this.getAuthHeaderOption()).map(res => res.json());
        }
        else if (type == "edit") {
            return this.http.put(this.common_api_url + 'language/update/' + id, { "language": obj.language, 'language_code': obj.language_code }, this.getAuthHeaderOption()).map(res => res.json());
        }
        else if (type == "delete") {
            return this.http.get(this.common_api_url + 'language/delete/' + id, this.getAuthHeaderOption()).map(res => res.json());
        }
    }

    //Manage Country
    manageCountry = function (obj, id, type) {
        if (type == "add") {
            return this.http.post(this.common_api_url + 'country/add/', { "country": obj.country, 'countrycode': obj.countrycode }, this.getAuthHeaderOption()).map(res => res.json());
        }
        else if (type == "edit") {
            return this.http.put(this.common_api_url + 'country/update/' + id, { "country": obj.country, 'countrycode': obj.countrycode }, this.getAuthHeaderOption()).map(res => res.json());
        }
        else if (type == "delete") {
            return this.http.get(this.common_api_url + 'country/delete/' + id, this.getAuthHeaderOption()).map(res => res.json());
        }
    }
    //Manage Country
    manageState = function (obj, type, id,) {
        // ;;
        if (type == "add") {
            return this.http.post(this.common_api_url + 'state/add/', { "state": obj.state, 'country_id': obj.country_id }, this.getAuthHeaderOption()).map(res => res.json());
        }
        else if (type == "edit") {
            return this.http.put(this.common_api_url + 'state/update/' + id, { "state": obj.state, 'country_id': obj.country_id }, this.getAuthHeaderOption()).map(res => res.json());
        }
        else if (type == "delete") {
            return this.http.get(this.common_api_url + 'state/delete/' + id, this.getAuthHeaderOption()).map(res => res.json());
        }
    }

    getLikeActivityRepoort = function (pageNo, limit, queryPrams) {
        return this.http.get(this.api_url + 'likeAdminList/' + pageNo + "/" + limit + '/?' + queryPrams, this.getAuthHeaderOption()).map(res => res.json());
    }

    getlikeMySurveyList = function (pageNo, limit, user_id) {
        return this.http.get(this.api_url + 'likeMySurveyList/' + pageNo + "/" + limit + '/?user_id=' + user_id, this.getAuthHeaderOption()).map(res => res.json());
    }


    FavouriteGroupSurveyList = function (pageNo, limit) {
        return this.http.get(this.common_api_url + 'group/favourite-group-survey-list-admin/' + pageNo + "/" + limit, this.getAuthHeaderOption()).map(res => res.json());
    }




    //Manage Country
    manageCity = function (obj, type, id,) {
        // ;;
        if (type == "add") {
            return this.http.post(this.common_api_url + 'city/add/', { "state_id": obj.state_id, 'country_id': obj.country_id, 'city': obj.city }, this.getAuthHeaderOption()).map(res => res.json());
        }
        else if (type == "edit") {
            return this.http.put(this.common_api_url + 'city/update/' + id, { "state_id": obj.state_id, 'country_id': obj.country_id, "city": obj.city, }, this.getAuthHeaderOption()).map(res => res.json());
        }
        else if (type == "delete") {
            return this.http.get(this.common_api_url + 'city/delete/' + id, this.getAuthHeaderOption()).map(res => res.json());
        }
    }

    //Manage Settings
    manageSettings = function (obj, id) {

        if (!id)
            return this.http.post(this.common_api_url + 'admin/settings', JSON.stringify(obj), this.getAuthHeaderOption()).map(res => res.json());
        else
            return this.http.put(this.common_api_url + 'admin/settings/' + id, JSON.stringify(obj), this.getAuthHeaderOption()).map(res => res.json());
    }

    //get Settings
    getSettings = function () {
        // // ;;;
        return this.http.get(this.common_api_url + 'admin/settings/get', this.getAuthHeaderOption()).map(res => res.json());
    }

    // Get selected user survey
    getSelectedUserSurvey = function (pageNo, limit, userId, is_group_survey_report) {
        return this.http.get(this.common_api_url + 'survey/get-user-servey-for-admin/' + pageNo + "/" + limit + "?user_id=" + userId + "&search=&is_expired=0", this.getAuthHeaderOption()).map(res => res.json());
    }

    // Get user profile
    getUserProfile = function (userId) {
        return this.http.get(this.common_api_url + "select/" + userId, this.getAuthHeaderOption()).map(res => res.json());
    }

    getSingleCategory = function (category_id) {
        return this.http.get(this.common_api_url + "category/get-single-category/" + category_id, this.getAuthHeaderOption()).map(res => res.json());
    }

    // Manage Category
    manageCategory = function (obj, type) {
        if (type == "add") {
            return this.http.post(this.common_api_url + "category/add", JSON.stringify(obj), this.getAuthHeaderOption()).map(res => res.json());
        }
        else if (type == "update") {
            return this.http.put(this.common_api_url + "category/update/" + obj._id, JSON.stringify(obj), this.getAuthHeaderOption()).map(res => res.json());
        }
        else {
            return this.http.get(this.common_api_url + "category/delete/" + obj._id, this.getAuthHeaderOption()).map(res => res.json());
        }
    }

    addCategory = function (obj) {
        return this.http.post(this.common_api_url + "category/add-category-with-language", JSON.stringify(obj), this.getAuthHeaderOption()).map(res => res.json());
    }

    updateCategory = function (obj) {
        return this.http.put(this.common_api_url + "category/update-category-with-language/" + obj.id, JSON.stringify(obj), this.getAuthHeaderOption()).map(res => res.json());
    }


    // Manage Profession
    manageProfession = function (obj, type) {
        if (type == "add") {
            return this.http.post(this.common_api_url + "profession/add", JSON.stringify(obj), this.getAuthHeaderOption()).map(res => res.json());
        }
        else if (type == "update") {
            return this.http.put(this.common_api_url + "profession/update/" + obj._id, JSON.stringify(obj), this.getAuthHeaderOption()).map(res => res.json());
        }
        else {
            return this.http.get(this.common_api_url + "profession/delete/" + obj._id, this.getAuthHeaderOption()).map(res => res.json());
        }
    }

    addProfession = function (obj) {
        return this.http.post(this.common_api_url + "profession/add-profession-with-language", JSON.stringify(obj), this.getAuthHeaderOption()).map(res => res.json());
    }

    updateProfession = function (obj) {
        return this.http.put(this.common_api_url + "profession/update-profession-with-language/" + obj.id, JSON.stringify(obj), this.getAuthHeaderOption()).map(res => res.json());
    }

    getSingleProfession = function (id) {
        return this.http.get(this.common_api_url + "profession/get-single-profession/" + id, this.getAuthHeaderOption()).map(res => res.json());
    }

    // get language
    getLanguage = function (pageNo, limit, searchStr) {
        return this.http.get(this.common_api_url + 'language/list/' + pageNo + "/" + limit + "?search=" + searchStr, this.getHeaderOption()).map(res => res.json());
    }

    // Get country list
    getCountry = function (pageNo, limit, searchStr) {
        return this.http.get(this.common_api_url + 'country/list/' + pageNo + "/" + limit + "?search=" + searchStr, this.getHeaderOption()).map(res => res.json());
    }

    // Get survey by id
    getSurveyById = function (surveyId) {
        return this.http.get(this.common_api_url + "survey/select/" + surveyId, this.getAuthHeaderOption()).map(res => res.json());
    }

    // Get survey report
    getSurveyReport = function (pageNo, limit, time) {
        console.log("dddd")
        return this.http.get(this.common_api_url + "survey/list-by/" + pageNo + "/" + limit + "?time=" + time, this.getAuthHeaderOption()).map(res => res.json());
    }

    // Get world view question list
    getWorldViewQuestionsList = function (request) {
        return this.http.post(this.api_url + "getallaskwazwazzerquestion/", request, this.getAuthHeaderOption()).map(res => res.json());
    }

    // Set world view question
    saveWorldViewQuestion = function (question, questionId) {
        if (questionId)
            return this.http.put(this.api_url + "update-world-question/" + questionId, JSON.stringify(question), this.getAuthHeaderOption()).map(res => res.json());
        return this.http.post(this.api_url + "set-world-question", JSON.stringify(question), this.getAuthHeaderOption()).map(res => res.json());
    }

    // Set world Next question
    saveWorldNextQuestion = function (nextQuestionDetail, question_id) {
        if (question_id)
            return this.http.put(this.api_url + "world-next-week-question", JSON.stringify(nextQuestionDetail), this.getAuthHeaderOption()).map(res => res.json());
        return this.http.post(this.api_url + "world-next-week-question", JSON.stringify(nextQuestionDetail), this.getAuthHeaderOption()).map(res => res.json());
    }

    // Get world view Question
    getWorldViewQuestion = function () {
        return this.http.get(this.api_url + "get-world-question", this.getAuthHeaderOption()).map(res => res.json());
    }

    // Get Waz next Question
    getWorldNextQuestion = function () {
        return this.http.get(this.api_url + "world-next-week-question", this.getAuthHeaderOption()).map(res => res.json());
    }

    // Get dashboard item
    getDashboardItem = function () {
        return this.http.get(this.api_url + "dashbordCount", this.getAuthHeaderOption()).map(res => res.json());
    }

    // App Purchase Form
    appPurchase = function (appPurchaseData, appPurchaseId) {
        if (appPurchaseId) {
            return this.http.put(this.api_url + "in-app-purchase/" + appPurchaseId, JSON.stringify(appPurchaseData), this.getAuthHeaderOption()).map(res => res.json());
        }
        return this.http.post(this.api_url + "in-app-purchase", JSON.stringify(appPurchaseData), this.getAuthHeaderOption()).map(res => res.json());
    }

    // Get App Purchase Data
    getAppPurchaseData = function () {
        return this.http.get(this.api_url + "in-app-purchase", this.getAuthHeaderOption()).map(res => res.json());
    }

    // Get dashboard user list
    getDashboardUserList = function (pageNo, limit, type) {
        return this.http.get(this.api_url + 'users-list/' + pageNo + '/' + limit + '/' + type, this.getAuthHeaderOption()).map(res => res.json());;
    }

    getUserList = function (pageNo, limit, type, status) {
        console.log(this.api_url + 'get-users/' + pageNo + '/' + limit + '/' + status + '/' + type)
        return this.http.get(this.api_url + 'get-users/' + pageNo + '/' + limit + '/' + status + '/' + type, this.getAuthHeaderOption()).map(res => res.json());;
    }

    getWeeklyUserList = function (pageNo, limit, status, date) {
        console.log(this.api_url + 'get-weekly-users/' + pageNo + '/' + limit + '/' + status + '/' + date)
        return this.http.get(this.api_url + 'get-weekly-users/' + pageNo + '/' + limit + '/' + status + '/' + date, this.getAuthHeaderOption()).map(res => res.json());;
    }

    // Get Answered Survey List
    getAnsweredSurveyList = function (pageNo, limit, time) {
        return this.http.get(this.common_api_url + "survey/answer-by/" + pageNo + "/" + limit + "?time=" + time, this.getAuthHeaderOption()).map(res => res.json());
    }

    // Get survey option
    getsurveyOption = function (surveyId, time) {
        return this.http.get(this.common_api_url + "survey/survey-answer-count/" + time + "/" + surveyId, this.getAuthHeaderOption()).map(res => res.json());
    }

    // Get paypal configuration data
    getPaypalConfigurationData = function () {
        return this.http.get(this.api_url + "paypal-config", this.getAuthHeaderOption()).map(res => res.json());
    }

    // Save paypal configuration data
    savePaypalConfiguration = function (data, paypalConfgId) {
        return this.http.post(this.api_url + "paypal-config?ID=" + paypalConfgId, JSON.stringify(data), this.getAuthHeaderOption()).map(res => res.json());
    }

    // Save twilio configuration data
    saveTwilioConfiguration = function (data) {
        return this.http.post(this.common_api_url + 'admin/updateTwilioConfiguration', data, this.getAuthHeaderOption()).map(res => res.json());
    }

    // Get transaction report
    getTransactionReport = function (pageNo, limit, time) {
        return this.http.get(this.api_url + "transaction-list/" + pageNo + "/" + limit + "/" + time, this.getAuthHeaderOption()).map(res => res.json());
    }


    //Group related function
    getGroupSettings = function () {
        return this.http.get(this.common_api_url + "group/get-group-settings", this.getAuthHeaderOption()).map(res => res.json());
    }

    //Save group settings
    saveGroupSettings = function (setting_id, object) {
        console.log(setting_id, object);
        if (setting_id)
            return this.http.put(this.common_api_url + "group/update-group-settings/" + setting_id, JSON.stringify(object), this.getAuthHeaderOption()).map(res => res.json());
        return this.http.post(this.common_api_url + "group/add-group-settings/", JSON.stringify(object), this.getAuthHeaderOption()).map(res => res.json());
    }

    // Get survey list
    getGroupSurveyList = function (page, limit, surveyTypeId, categoryId, surveyStatus, searchStr, group_id) {
        if (group_id)
            return this.http.get(this.common_api_url + 'group/all-survey-for-admin/' + page + "/" + limit + "?group_id=" + group_id + "&category_id=" + categoryId + "&is_expired=" + surveyStatus + "&search=" + searchStr, this.getAuthHeaderOption()).map(res => res.json());
        return this.http.get(this.common_api_url + 'group/all-survey-for-admin/' + page + "/" + limit + "?category_id=" + categoryId + "&is_expired=" + surveyStatus + "&search=" + searchStr, this.getAuthHeaderOption()).map(res => res.json());
    }

    // Update survey status
    updateGroupSurveyStatus = function (id) {
        return this.http.put(this.common_api_url + 'group/update-group-survey-status/' + id, {}, this.getAuthHeaderOption()).map(res => res.json());
    }

    // Delete group survey
    deleteGroupSurvey = function (id) {
        return this.http.delete(this.common_api_url + 'group/delete-survey-by-admin/' + id, this.getAuthHeaderOption()).map(res => res.json());
    }

    //Get all groups list
    getAllGroupsList = function () {
        return this.http.get(this.common_api_url + 'group/get-all-groups', this.getAuthHeaderOption()).map(res => res.json());
    }

    // Get group survey by id
    getGroupSurveyById = function (survey_id, group_id) {
        return this.http.get(this.common_api_url + "group/select-servey/" + survey_id + "/" + group_id, this.getAuthHeaderOption()).map(res => res.json());
    }

    //Get All Group List to Display in Admin
    getAllGroupsListinAdmin(page, limit, search_text) {
        if (!search_text)
            return this.http.get(this.common_api_url + 'group/get-all-groups-for-admin/' + page + '/' + limit, this.getAuthHeaderOption()).map(res => res.json());
        else
            return this.http.get(this.common_api_url + 'group/get-all-groups-for-admin/' + page + '/' + limit + '?search=' + search_text, this.getAuthHeaderOption()).map(res => res.json());
    }

    getAllSocietyGroupsListinAdmin(page, limit, search_text) {
        if (!search_text)
            return this.http.get(this.common_api_url + 'group/get-all-societygroups-for-admin/' + page + '/' + limit, this.getAuthHeaderOption()).map(res => res.json());
        else
            return this.http.get(this.common_api_url + 'group/get-all-societygroups-for-admin/' + page + '/' + limit + '?search=' + search_text, this.getAuthHeaderOption()).map(res => res.json());
    }

    // Delete group 
    deleteGroup = function (id) {
        return this.http.delete(this.common_api_url + 'group/delete-group-by-admin/' + id, this.getAuthHeaderOption()).map(res => res.json());
    }

    getGroupMembersList(page, limit, group_id) {
        console.log()
        return this.http.get(this.common_api_url + 'group/get-group-members/' + page + '/' + limit + '/' + group_id, this.getAuthHeaderOption()).map(res => res.json());
    }




    //05sep2018
    // Get survey list
    getSurveyCommentList = function (page, limit, surveyTypeId, categoryId, surveyStatus, searchStr) {

        return this.http.get(this.common_api_url + 'admin/getcommentadmin/' + page + '/' + limit, this.getAuthHeaderOption()).map(res => res.json());
    }
    // Get survey list
    getVideoreportList = function (page, limit, surveyTypeId, categoryId, surveyStatus, searchStr) {

        return this.http.get(this.common_api_url + 'admin/Reportvideolist/' + page + '/' + limit, this.getAuthHeaderOption()).map(res => res.json());
    }

    getVideQuestionreportList = function (page, limit, param) {
        return this.http.get(this.api_url + 'getall-videoreport-questions/' + page + '/' + limit + '?' + param, this.getAuthHeaderOption()).map(res => res.json());
    }

    getWazVideWazQuestions = function (data) {
        return this.http.post(this.api_url + 'getallaskwazwazzerquestionVideo/', data, this.getAuthHeaderOption()).map(res => res.json());
    }

    // Delete survey
    deleteSurveyComment = function (id) {
        // // ;;
        //  var datamain ={ "_id":  id}
        // // ;;;
        return this.http.put(this.common_api_url + 'admin/survey/deletecomments', JSON.stringify({ _id: id }), this.getAuthHeaderOption()).map(res => res.json());
    }

    getSurveyActivityReportList = function (page, limit, surveyTypeId, categoryId, startdate, enddate) {
        //        return this.http.get(this.common_api_url + 'admin/getactivityreport-adminsearch/' + page + '/' + limit + '?surveycategory=' + surveyTypeId + '&activitycategory=' + categoryId,'&startdate='+startdate,'&enddate='+enddate, this.getAuthHeaderOption()).map(res => res.json());
        return this.http.get(this.common_api_url + 'admin/getactivityreport-adminsearch/' + page + '/' + limit + '?surveycategory=' + surveyTypeId + '&activitycategory=' + categoryId + '&startdate=' + startdate + '&enddate=' + enddate, this.getAuthHeaderOption()).map(res => res.json());
        // return this.http.get(this.common_api_url + 'admin/getactivityreport-admin/' + page + '/' + limit, this.getAuthHeaderOption()).map(res => res.json());
    }

    // Delete survey activity report
    deleteSurveyActivityReport = function (id) {

        return this.http.put(this.common_api_url + 'admin/deletereportactivity', JSON.stringify({ _id: id }), this.getAuthHeaderOption()).map(res => res.json());
    }

    //get profile verification list 
    getProfileVerificationReportList = function (page, limit, surveyTypeId, categoryId, surveyStatus, searchStr) {

        //return this.http.get(this.common_api_url + 'admin/getverifyreport', this.getAuthHeaderOption()).map(res => res.json());
        //getverifydocument-admin/1/5
        return this.http.get(this.common_api_url + 'admin/getverifydocument-admin/' + page + '/' + limit, this.getAuthHeaderOption()).map(res => res.json());
    }
    //get profile verification list 
    getFilteredProfileVerificationReportList = function (page, limit, fromdate, todate) {

        //return this.http.get(this.common_api_url + 'admin/getverifyreport', this.getAuthHeaderOption()).map(res => res.json());
        //getverifydocument-admin/1/5
        return this.http.get(this.common_api_url + 'admin/getverifydocument-admindate/' + page + '/' + limit + '/' + fromdate + '/' + todate, this.getAuthHeaderOption()).map(res => res.json());
    }


    // approve profile verification
    approveProfileVerification = function (id) {

        return this.http.put(this.common_api_url + 'admin/approveverifyid', JSON.stringify({ user_id: id }), this.getAuthHeaderOption()).map(res => res.json());
    }
    // reject profile verification
    rejectProfileVerification = function (id) {

        return this.http.put(this.common_api_url + 'admin/rejectverifyid', JSON.stringify({ user_id: id }), this.getAuthHeaderOption()).map(res => res.json());
    }

    GetLocalIpAddress = function (id) {

        // $.getJSON('http://ip.jsontest.com/?callback=?', function(data) {
        //     
        //     console.log(JSON.stringify(data, null, 2));
        //     return data.ip;
        // });
        // $.getJSON('https://ipapi.co/json/', function(data) {
        //     
        //     console.log(JSON.stringify(data, null, 2));
        // });

        $.getJSON('https://api.ipify.org?format=jsonp&callback=?', function (data) {

            console.log(JSON.stringify(data, null, 2));

            return JSON.stringify(data, null, 2);
        });
    }

    getAdminLogReportList(page, limit, group_id) {

        return this.http.get(this.common_api_url + 'admin/loggedin-list/' + page + '/' + limit, this.getAuthHeaderOption()).map(res => res.json());
    }


    getSurveyActivityReportListSearch = function (page, limit, surveyTypeId, categoryId, surveyStatus, searchStr) {

        return this.http.get(this.common_api_url + 'admin/getactivityreport-adminsearch/' + page + '/' + limit + '?surveycategory=' + surveyTypeId + '&activitycategory=' + categoryId, this.getAuthHeaderOption()).map(res => res.json());
    }

    getReportedCommentList = function (page, limit, surveyTypeId, categoryId, surveyStatus, searchStr) {

        return this.http.get(this.common_api_url + 'admin/getcommentreport-admin/' + page + '/' + limit + '?surveycategory=' + surveyTypeId + '&activitycategory=' + categoryId, this.getAuthHeaderOption()).map(res => res.json());
    }
    // Delete survey activity report
    deleteReportedComment = function (id) {
        return this.http.put(this.common_api_url + 'admin/deletecommentreport', JSON.stringify({ _id: id }), this.getAuthHeaderOption()).map(res => res.json());
    }


    validateFields(field, type) {
        if (type == 1)
            return this.http.get(this.api_url + 'check-validation/' + type + '/' + field, this.getAuthHeaderOption()).map(res => res.json());
        else if (type == 2)
            return this.http.get(this.api_url + 'check-validation/' + type + '/' + field, this.getAuthHeaderOption()).map(res => res.json());
        else if (type == 3)
            return this.http.get(this.api_url + 'check-validation/' + type + '/' + field, this.getAuthHeaderOption()).map(res => res.json());
    }


    // get user credit transaction report
    getAllUserCreditTransactionReport = function (page, limit) {

        return this.http.get(this.api_url + 'transaction-listcredit/' + page + '/' + limit, this.getAuthHeaderOption()).map(res => res.json());
    }

    // get user credit report by id 
    getUserCreditReport = function (userId) {

        return this.http.get(this.api_url + 'transaction-listcredituser/' + userId, this.getAuthHeaderOption()).map(res => res.json());

    }

    askWazzers = function (userId) {
        return this.http.get(this.api_url + 'getaskwazwazzerquestion/' + userId, this.getAuthHeaderOption()).map(res => res.json());
    }

    getLikeUsers = function (usersArr) {
        return this.http.post(this.api_url + 'getlikeusers/', JSON.stringify({ 'users': usersArr }), this.getAuthHeaderOption()).map(res => res.json());
    }

    showProfileCount = function (user_id) {
        return this.http.get(this.api_url + 'showProfileCount/' + user_id, this.getAuthHeaderOption()).map(res => res.json());
    }


    getUserQuestionVideoList(questionId, userId) {
        return this.http.get(this.api_url + 'checkvideostatusonaskwazzer/' + questionId + '/' + userId, this.getAuthHeaderOption()).map(res => res.json());
    }


    getTopFavoriteSurveys = function (pageNo, limit, searchStr, categoryId, surveyStatus, range, target) {
        if (categoryId) {
            return this.http.get(this.common_api_url + 'survey/world-top-survey/' + pageNo + "/" + limit + "?search=" + searchStr + "&category_id=" + categoryId + "&is_expired=" + surveyStatus + "&range=" + range + "&target=" + target, this.getAuthHeaderOption()).map(res => res.json());
        }
        return this.http.get(this.common_api_url + 'survey/world-top-survey/' + pageNo + "/" + limit + "?search=" + searchStr + "&is_expired=" + surveyStatus + "&range=" + range + "&target=" + target, this.getAuthHeaderOption()).map(res => res.json());
    }

    // getRedeemListinAdmin(page, limit, search_text) {
    //     if (!search_text)
    //         return this.http.get(this.common_api_url + 'admin/redeemList/' + page + '/' + limit, this.getAuthHeaderOption()).map(res => res.json());
    //     else
    //         return this.http.get(this.common_api_url + 'admin/redeemList/' + page + '/' + limit + '?search=' + search_text, this.getAuthHeaderOption()).map(res => res.json());
    // }

    getRedeemListinAdmin(page, limit, search_text, param) {
        if (!param)
            return this.http.get(this.common_api_url + 'admin/redeemList/' + page + '/' + limit, this.getAuthHeaderOption()).map(res => res.json());
        else
            return this.http.get(this.common_api_url + 'admin/redeemList/' + page + '/' + limit + '?search=' + search_text + param, this.getAuthHeaderOption()).map(res => res.json());
    }

    getQueryList(page, limit, search_text, query_id) {
        if (!search_text)
            return this.http.get(this.common_api_url + 'admin/queryList/' + query_id + '/' + page + '/' + limit, this.getAuthHeaderOption()).map(res => res.json());
        else
            return this.http.get(this.common_api_url + 'admin/queryList/' + query_id + '/' + page + '/' + limit + '?search=' + search_text, this.getAuthHeaderOption()).map(res => res.json());
    }

    addQuery = function (data) {

        return this.http.post(this.common_api_url + 'admin/addQuery/', data, this.getAuthHeaderOption()).map(res => res.json());
    }

    updateRedeemStatus = function (data) {
        return this.http.post(this.common_api_url + 'admin/updateRedeemStatus', data, this.getAuthHeaderOption()).map(res => res.json());
    }

    updateCriteria = function (data) {
        return this.http.post(this.common_api_url + 'admin/updateCriteria', data, this.getAuthHeaderOption()).map(res => res.json());
    }

    getYearList = function () {
        return this.http.get(this.common_api_url + 'year/list', this.getAuthHeaderOption()).map(res => res.json());
    }

    authenticatePaypal = function () {
        return this.http.post(this.paypal_url + '/v1/oauth2/token', 'grant_type=client_credentials', this.getPaypalAuthHeaderOption()).map(res => res.json());
    }

    payThroughPaypal = function (accessToken) {
        return this.http.post(this.paypal_url + '/v1/payments/payouts', {
            "sender_batch_header": {
                "sender_batch_id": "paypal" + new Date().getTime(),//"2014021845",
                // "recipient_type": "PAYPAL_ID",//"PAYPAL_ID",//"EMAIL",
                "email_subject": "You have money!",
                "email_message": "You received a payment. Thanks for using our service!"
            },
            items: [{
                "amount": {
                    "value": "0.01",
                    "currency": "USD"
                },
                "sender_item_id": "paypal" + new Date().getTime(),
                "recipient_type": "EMAIL",
                // "recipient_wallet": "PAYPAL",//RECIPIENT_SELECTED//PAYPAL
                "receiver": "sb-47cvgu14115544@personal.example.com"//"47GXW9VBN45A2"// "dr_khalilo@hotmail.com"
            }]
        }, this.getPayAuthHeaderOption(accessToken)).map(res => res.json());
    }

    getPaymentDetail(accessToken, link) {
        return this.http.get(link, this.getPayAuthHeaderOption(accessToken)).map(res => res.json());
    }

    // get Business video  list
    getBusinessVideoList = function (page, limit, searchStr) {
        // ;;
        return this.http.get(this.common_api_url + 'admin/businessVideoList/' + page + "/" + limit + "?search=" + searchStr, this.getAuthHeaderOption()).map(res => res.json());
    }

    getBusinessVideoSearchList= function (page, limit, startdate, expirydate, videoCategory, videoCountry) {
        // ;;
        return this.http.get(this.common_api_url + 'admin/businessVideoSearchList/' + page + "/" + limit + "?startdate=" + startdate, "&expirydate=" + expirydate,"&videoCategory=" + videoCategory,"&videoCountry=" + videoCountry, this.getAuthHeaderOption()).map(res => res.json());
    }

    getInfluenceList = function (page, limit, searchStr) {
        // ;;
        return this.http.get(this.common_api_url + 'admin/getInfluenceList/' + page + "/" + limit + "?search=" + searchStr, this.getAuthHeaderOption()).map(res => res.json());
    }

    changeInfluenceStatus = function (data) {
        return this.http.post(this.common_api_url + 'admin/changeInfluenceStatus', data, this.getAuthHeaderOption()).map(res => res.json());
    }

    changeBusinessVideoStatus = function (data) {
        return this.http.post(this.common_api_url + 'admin/changeBusinessVideoStatus', data, this.getAuthHeaderOption()).map(res => res.json());
    }

    calculateExpiry = function (expiryTime) {
        this.surveyExpiryDate = new Date(expiryTime);
        this.currentDate = new Date();
        this.currentDate = new Date(this.currentDate.toISOString());
        var seconds = Math.floor((this.surveyExpiryDate - this.currentDate) / 1000);
        // if(Math.round(seconds/(60*60*24*365.25)) >= 2) return Math.round(seconds/(60*60*24*365.25)) + " years";
        // else if(Math.round(seconds/(60*60*24*365.25)) >= 1) return "1 year";
        // else if(Math.round(seconds/(60*60*24*30.4)) >= 2) return Math.round(seconds/(60*60*24*30.4)) + " months";
        // else if(Math.round(seconds/(60*60*24*30.4)) >= 1) return "1 month ";
        // else if(Math.round(seconds/(60*60*24*7)) >= 2) return Math.round(seconds/(60*60*24*7)) + " weeks";
        // else if(Math.round(seconds/(60*60*24*7)) >= 1) return "1 week";
        // else if(Math.round(seconds/(60*60*24)) >= 2) return Math.round(seconds/(60*60*24)) + " days";
        // else if(Math.round(seconds/(60*60*24)) >= 1) return "1 day ";
        // else if(Math.round(seconds/(60*60)) >= 2) return Math.round(seconds/(60*60)) + " hours";
        // else if(Math.round(seconds/(60*60)) >= 1) return "1 hour";
        // else if(Math.round(seconds/60) >= 2) return Math.round(seconds/60) + " minutes";
        // else if(Math.round(seconds/60) >= 1) return "1 minute";
        // else if(seconds >= 2)return seconds + " seconds";
        // else if(seconds >= 1)return seconds + "1 second";
        // else return 'Expired';
        if (Math.round(seconds / (60 * 60 * 24 * 365.25)) >= 2) return Math.round(seconds / (60 * 60 * 24 * 365.25)) + " Years";
        // else if(Math.round(seconds/(60*60*24*365.25)) > 1) return "1 Year";
        else if (Math.round(seconds / (60 * 60 * 24 * 30.4)) >= 2) return Math.round(seconds / (60 * 60 * 24)) + " Days";
        else if (Math.round(seconds / (60 * 60 * 24)) >= 2) return Math.round(seconds / (60 * 60 * 24)) + " Days";
        else if (Math.round(seconds / (60 * 60 * 24)) >= 1 && Math.round(seconds / (60 * 60)) > 24) return "1 day ";
        else if (Math.round(seconds / (60 * 60)) >= 2) return Math.round(seconds / (60 * 60)) + " Hours";
        else if (Math.round(seconds / (60 * 60)) >= 1) return "1 Hour";
        else if (Math.round(seconds / 60) >= 2) return Math.round(seconds / 60) + " Minutes";
        else if (Math.round(seconds / 60) >= 1) return "1 Minute";
        else if (seconds >= 2) return seconds + " Seconds";
        else if (seconds >= 1) return seconds + "1 Second";
        else return 'Few Seconds';
    };

    // point section
    getUserPointDataList = function (page, limit, searchStr) {
        console.log(this.api_url + 'getAllUserPoint/' + page + "/" + limit + "?search=" + searchStr)
        return this.http.get(this.api_url + 'getAllUserPoint/' + page + "/" + limit + "?search=" + searchStr, this.getHeaderOption()).map(res => res.json());
    }

    managePoint = function (obj, type, id,) {
        // ;;
        if (type == "delete") {
            return this.http.get(this.api_url + 'deletePoint/' + id, this.getAuthHeaderOption()).map(res => res.json());
        }
    }

    //story section
    getUserStoryDataList = function (page, limit, searchStr) {
        console.log(this.api_url + 'getAllUserStory/' + page + "/" + limit + "?search=" + searchStr)
        return this.http.get(this.api_url + 'getAllUserStory/' + page + "/" + limit + "?search=" + searchStr, this.getHeaderOption()).map(res => res.json());
    }

    //story video section
    getUserStoryVideoDataList = function (user_id ,page, limit, searchStr) {
        console.log(this.api_url + 'getUserStoryVideo/' + user_id + "/" + page + "/" + limit + "?search=" + searchStr)
        return this.http.get(this.api_url + 'getUserStoryVideo/' +user_id + "/" + page + "/" + limit + "?search=" + searchStr, this.getHeaderOption()).map(res => res.json());
    }

    manageStoryVideo = function (obj, type, id,) {
        if (type == "delete") {
            return this.http.get(this.api_url + 'deleteStoryVideo/' + id, this.getAuthHeaderOption()).map(res => res.json());
        }
    }

    manageStory = function (obj, type, id,) {
        // ;;
        if (type == "delete") {
            //console.log(this.api_url)
            return this.http.get(this.api_url + 'deleteStory/' + id, this.getAuthHeaderOption()).map(res => res.json());
        }
    }

}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/services/auth.service.ts